import { render } from "./none.vue?vue&type=template&id=0279ad42"
const script = {}

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__